import {
    loadDealsRequest,
    loadDealRequest,
} from 'src/repositories/deal.repository';

/**
 * Action Types
 */
export const DEALS_LOADING = 'DEALS_LOADING';
export const DEALS_LOADED = 'DEALS_LOADED';
export const DEAL_LOADING = 'DEAL_LOADING';
export const DEAL_LOADED = 'DEAL_LOADED';

/**
 * Action Creators
 */

export const loadingDeals = isLoading => ({
    type: DEALS_LOADING,
    payload: isLoading,
});

export const loadedDeals = deals => ({
    type: DEALS_LOADED,
    payload: deals,
});

export const loadingDeal = isLoading => ({
    type: DEAL_LOADING,
    payload: isLoading,
});

export const loadedDeal = deal => ({
    type: DEAL_LOADED,
    payload: deal,
});

/**
 * Actions
 */

/**
 * Load all deals
 * @param {object} params
 */
export const loadDeals = params => (dispatch) => {
    dispatch(loadingDeals(true));
    return loadDealsRequest(params)
        .then(({ data }) => {
            dispatch(loadedDeals(data));
        })
        .finally(() => {
            dispatch(loadingDeals(false));
        });
};

/**
 * Load specific deal
 * @param {number} id
 */
export const loadDeal = id => (dispatch) => {
    dispatch(loadingDeal(true));
    return loadDealRequest(id)
        .then(({ data }) => {
            dispatch(loadedDeal(data));
        })
        .finally(() => {
            dispatch(loadingDeal(false));
        });
};
